
import { Vue, Component, Prop } from "vue-property-decorator";
import { TemplatePreviewableItem } from "@/types/templates";

@Component
export default class PreviewChooserNothingToPreview extends Vue {
  @Prop()
  previewItem?: TemplatePreviewableItem;

  @Prop()
  nothingToPreview!: boolean;
}
